import { z } from 'zod';

import { schemaApplicantAttribution, schemaBigDecimal, schemaId } from '../../../utils/schema.utils';

// `notiz` is C-Pool only: Europace offers no free-text field on sonstige Einnahmen, so it is not synced.
export const SonstigeEinnahme = z.object({
    betragMonatlich: schemaBigDecimal.nullish().default(null),
    gehoertZuAntragsteller: schemaApplicantAttribution,
    id: schemaId,
    notiz: z.string().nullish().default(null),
});
